
import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "./context/auth";

function PrivateRoute({ component: Component, ...rest }) {
    const {authToken, role} = useAuth();
    return (
        <Route
            {...rest}
            render={props => {
                if (authToken && role == "guest")
                    return <Redirect to="/guest"/>

                if (authToken)
                    return <Component {...props} />

                return <Redirect to="/login"/>
            }
            }
        />
    );
}

export default PrivateRoute;